import React from 'react';
import PropTypes from 'prop-types';
import { CVGPlot } from 'components/plots';

export const Simple = ({ tm30 }) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <div id='simple'>
        <div style={{ margin: '1rem 2rem' }}>
          <CVGPlot numericalResults={tm30} active='simple'></CVGPlot>
        </div>
      </div>
    </div>
  );
};

Simple.propTypes = {
  tm30: PropTypes.object,
};
